<template>
  <div class="sc-grid-item">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'sc-grid-item',
};
</script>

<style lang="scss" scoped>
.sc-grid-item {
  display: flex;
  justify-content: space-between;
  padding: 7px 10px;
  overflow-wrap: break-word;
  border-bottom: 1px solid #e7e7e7;
  border-left: 1px solid #e7e7e7;

  @media (max-width: 600px) {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-ctes/components/ScGridItem.vue